import { render, staticRenderFns } from "./squad.vue?vue&type=template&id=68c9f592&"
import script from "./squad.vue?vue&type=script&lang=js&"
export * from "./squad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports